import React from 'react'
import { Dropdown } from 'react-bootstrap';
import MapBox from "../../../../components/MapBox/MapBox";
import { GeoRiskData } from "../../../Scan/data/MapData";
import styles from "./Incidents.module.scss";


export default function Incidents() {

  const datas = [
    {
      title: "Failure of supply chain due to geopolitical issues",
      location: "Europe",
      risk: 2,
    },
    {
      title:
        "Business disruption due to issues such as equipment failure or system malfunctions",
      location: "Asia",
      risk: 0,
    },
    {
      title:
        "Negative publicity or damage to a company's reputation due to factors such as product recalls or ethical lapses",
      location: "USA, NY",
      risk: 1,
    },
    {
      title:
        "Financial loss due to fraudulent activities such as embezzlement, identity theft, or accounting fraud",
      location: "USA, Europe, Asia",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Business disruption or loss due to technological failures, cyberattacks, or obsolete technology",
      location: "Global",
      risk: 0,
    },
    {
      title: "Delays, cost overruns, or failure to achieve project objectives",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "Asia",
      risk: 1,
    },
    {
      title:
        "Financial or legal penalties due to failure to comply with internal policies or external regulations",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 1,
    },
  ];

      const riskStatus = (risk: number) => {
        let dotColor = "bg-white";
        let riskLabel = "Medium decreasing";
        if (risk === 2) {
          dotColor = "bg-error-600";
          riskLabel = "High increasing";
        } else if (risk === 1) {
          dotColor = "bg-indigo-600";
          riskLabel = "Medium increasing";
        }
        return (
          <>
            <span className={"dot mr-2 " + dotColor}></span>
            riskLabel
          </>
        );
      };
  return (
    <div className="row">
      <div className="col-6">
        <h5 className="fw-300">Risk Universe</h5>
        <h1 className="fw-300">Incidents</h1>
        <p className="text-gray-400 fw-300">
          An incident involves some sort of negative event tied to a risk. This
          could be anything from IT-related risks like a data breach or physical
          risks like a tornado or an employee tripping and falling.
        </p>
        <hr />

        <div className="d-flex justify-content-between">
          <h3 className="fw-300 ">Top Incidents</h3>
          <Dropdown>
            <Dropdown.Toggle size="lg" variant="outline-secondary">
              Actions
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <small className="text-gray-500">
          Risks we recognize as affecting your organization
        </small>

        <ul className="time-line mt-3">
          {datas.map((data, i) => (
            <li className="d-flex justify-content-between" key={i}>
              <div className="d-inline-flex align-items-center">
                <div className="ml-3">
                  <h6 className="text-gray-50 fw-400">{data.title}</h6>
                  <span className="text-gray-400 fw-300">
                    <small className="text-uppercase text-7s">
                      {/* data.risk */}
                      {riskStatus(data.risk)}
                    </small>
                    <span className="text-gray-500">
                      <span className="mh-2">|</span>
                      <i className="icon-map-pin mr-2 text-2c"></i>
                      {data.location}
                    </span>
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-6">
        <div className={styles.map}>
          <div className={styles.mapHolder}>
            <MapBox
              mapHeight="5rem"
              zoom={2.9}
              showControl={false}
              riskMarkers={GeoRiskData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
